import React from "react";
import {Link} from "react-router-dom";
import {parseISO} from "date-fns";
import {
    containsSelectAll,
    createCalculatedColumn,
    createColumn,
    createComponentColumn,
    createPaginatedSelectRowComponentColumn
} from "../../../utils/ColumnUtils";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import {calculateAnlagenLink} from "../../../initialObjects/AnlageObjects";
import {formatDate} from "../../../utils/DateUtils";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import EAPaginatedTable from "../../EAPaginatedTable";
import EAButtonBar from "../../EAButtonBar";
import EADownloadButton from "../../EADownloadButton";
import {postAnlagenExportAllEndpointConfiguration, postAnlagenExportEndpointConfiguration} from "../../../services/AnlagenService";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBA, ZUST_SBB, ZUST_SBD, ZUST_SBS} from "../../../consts/funktionaleRollen";

export default function AnlageArbeitsListeTable({
                                                    id,
                                                    loading,
                                                    data,
                                                    history,
                                                    storedFilter,
                                                    setStoredFilter,
                                                    selected,
                                                    sharedFilter,
                                                    createQuery,
                                                    setSelected
                                                }) {


    const anlageColumns = [
        createPaginatedSelectRowComponentColumn("anlageArbeitsliste", "id", selected, setSelected),
        createComponentColumn(
            "actions",
            (row, index) => {
                return (
                    <div className="eatabwrapper">
                        {editAllowed() && (
                            <EATableActionButton id={"abs-" + index} iconName="ico-edit">
                                <Link to={calculateAnlagenLink(row, "modus=s")}/>
                            </EATableActionButton>
                        )}
                        <EATableActionButton id={"abl-" + index} iconName="ico-view">
                            <Link to={calculateAnlagenLink(row)}/>
                        </EATableActionButton>
                    </div>
                );
            },
            "",
            null,
            {padding: 0, width: "50px", minWidth: "50px", maxWidth: "50px"}
        ),
        createColumn("anlagenId", "Anlagennummer"),
        createColumn("bezeichnung", "Abwasseranlage"),
        createColumn("anlagentyp.value", "Anlagentyp"),
        createColumn("organisation.value", "Betreiber"),
        createColumn("betriebTyp.value", "Betriebstyp"),
        createColumn("currentAbwasserbeseitigungspflichtiger.organisation.value", "Abwasserbeseitigungspflichtiger", {maxWidth: "185px"}),
        createColumn("anlagenstatus.value", "Status"),
    ];
    if ((sharedFilter.gueltigVon || sharedFilter.gueltigBis) && !sharedFilter.personalisiert) {
        anlageColumns.push(
            createCalculatedColumn(
                "auditInfo.gueltigAb",
                (row) => (row?.auditInfo?.gueltigAb ? formatDate(parseISO(row.auditInfo.gueltigAb)) : null),
                "Gültig von"
            )
        );
        anlageColumns.push(
            createCalculatedColumn(
                "auditInfo.gueltigBis",
                (row) => (row?.auditInfo?.gueltigBis ? formatDate(parseISO(row.auditInfo.gueltigBis)) : null),
                "Gültig bis"
            )
        );
    }

    const editAllowed = () => {
        return userHasAnyRole([SYSTEMADMIN, FACHADMIN, BETREIBER, BEAUFTRAGTER, ZUST_SBD, ZUST_SBB, ZUST_SBS, ZUST_SBA]);
    }

    return (
        <>
            <EAPaginatedTable
                id={id}
                loading={loading}
                columns={anlageColumns}
                data={data}
                onDoubleClick={(row) => {
                    history.push(calculateAnlagenLink(row));
                }}
                onAltDoubleClick={(row) => {
                    if (editAllowed()) {
                        history.push(calculateAnlagenLink(row, "modus=s"));
                    }
                }}
                pageInfo={storedFilter.pageInfo}
                setPageInfo={(pageInfo) => {
                    setStoredFilter({...storedFilter, pageInfo});
                }}
            />
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EADownloadButton
                    id={"exportArbeitsliste"}
                    loading={loading}
                    label={"Excel-Export"}
                    disabled={!selected || selected.length === 0}
                    config={containsSelectAll(selected) ?
                        postAnlagenExportAllEndpointConfiguration(createQuery({...storedFilter, ...sharedFilter}))
                        : postAnlagenExportEndpointConfiguration(selected)}
                    style={{marginRight: "auto"}}
                />
            </EAButtonBar>
        </>
    );
}
